import { jsx as _jsx } from "react/jsx-runtime";
import styled from 'styled-components';
const StyledBody = styled.div `
    position: relative;
`;
const ProgressBody = ({ children }) => (_jsx(StyledBody, { children: children }));
export default ProgressBody;
